import React, { Component } from "react";
import { Row, Col, Card, CardBody} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import {
  getInitiatedBookings
} from "../../store/initiatedBookings/actions";
import { connect } from "react-redux";
import InitiatedBookingsList from "./List/InitiatedBookingsList";
import Paging from "../../components/Pagination/Pagination";
import {DatePicker, Space} from "antd";
import moment from "moment";
import ListSearch from "components/ListSearch/ListSearch";

class InitiatedBookings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      currentDate: moment(new Date())
    }
  }

  componentDidMount() {
    this.props.getInitiatedBookings({currentPage: this.state.currentPage, currentDate: this.state.currentDate.format('YYYY-MM-DD')});
  }
  setPage = (currentPage) => {
    this.props.getInitiatedBookings({currentPage, currentDate: this.state.currentDate.format('YYYY-MM-DD')});
    this.setState({currentPage, currentDate: this.state.currentDate})
  }
  setDatePickFrom = (date) => {
    this.props.getInitiatedBookings({currentPage: 1, currentDate: date.format('YYYY-MM-DD')});
    this.setState({currentPage: 1, currentDate: date})
  }
  handleSearch = (q) => {
    this.props.getInitiatedBookings({
      currentPage: 1,
      currentDate: this.state.currentDate.format('YYYY-MM-DD'),
      q
    });
    this.setState({currentPage: 1})
  }
  render() {
    const { initiatedList, query } = this.props;
    const q = query?.q;
    return (
      <React.Fragment>
        <div className="page-content">
          <div className="container-fluid">
            <Breadcrumbs title="Започнати резервации" breadcrumbItem="Започнати резервации" />
            <Row>
              <Col>
                <Space className='pb-1 w-100' wrap>
                  <DatePicker
                    placeholder="Текуща дата"
                    onChange={(date, dateString) => this.setDatePickFrom(moment(dateString))}
                    style={{
                      width: "130px",
                      marginRight: "15px",
                    }}
                  />
                  <ListSearch
                    value={q || ""}
                    onSearch={this.handleSearch}
                    placeholder="Търсене по стопанин"
                  />
                </Space>
                <Space direction="horizental float-sm-right" style={{alignItems: 'center'}}>
                  <div><b>Общо:</b> {initiatedList?.total ?? 0}</div>
                </Space>
                <Card>
                  <Paging setPage={this.setPage} pages={initiatedList?.pages} currentPage={this.state.currentPage}/>
                  <CardBody>
                    <InitiatedBookingsList
                      list={initiatedList?.bookingSteps}
                      history={this.props.history}
                    />
                  </CardBody>
                  <Paging setPage={this.setPage} pages={initiatedList?.pages} currentPage={this.state.currentPage}/>
                </Card>
              </Col>
            </Row>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { InitiatedBookings } = state;
  return InitiatedBookings;
};

export default
connect(mapStatetoProps, {
  getInitiatedBookings,
})(InitiatedBookings);
